import $ from 'jquery';
import CookieConsent from './CookieConsent';

export default class GoogleTrackingService {

    constructor() {
        this.bindEvents();
    }

    bindEvents() {
        window.dataLayer = window.dataLayer || [];
        $(document).on(CookieConsent.COOKIE_LEVEL_EVENT_PREFIX + 'cookie-level-2', function (e, level) {
            window.dataLayer.push({
                event: level.toString()
            });
        });
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/accelerator/src/Accelerator/Components/Modules/CookieConsent/resources/scripts/front/CookieConsent/GoogleTrackingService.js